import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Container, Row, Col } from 'react-bootstrap';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { isEmpty, cloneDeep, uniqBy } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import SearchBar from '../../Components/Utility/FilterAction/SearchBar';
import Loader from '../../Components/Utility/Loader/Loader';
import BtnBack from '../../Components/Utility/FilterAction/BtnBack';
import * as userAction from '../UserSetting/store/User.action';
import * as action from './store/OprationalCP.action';
import { Page_Size, shortenString, complitionPercentage, createOptions } from '../../Components/helper';
import { toasterMsg } from '../../Components/Toaster/Toaster';
import FilterButton from '../../Components/Utility/FilterAction/FilterButton';
import RequiredFieldModal from './RequiredFieldModal';
import RenderingManualItems from '../ProductCP/RenderingManualItems';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';

function DetailsOprationalCPPage() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { ocpId } = useParams();
  const { t } = useTranslation('common');
  const lastFixColClass = 'last-fix-col';
  const { timeZone } = window.Intl.DateTimeFormat().resolvedOptions();

  const {
    Users: { userGroupsCardList, logInRights },
    UserDetails: { userInfo, isSupplierLoggedIn, isCompanyUserLoggedIn },
    oprationalCPDetails: { ocpRowColData, totalDetailsRow },
  } = useSelector((reducer) => reducer);
  const { CheckActionPermission } = useComponent();

  const searchParams = new URLSearchParams(location?.search);
  const locaStates = location?.state;
  const fromArch = searchParams.get('fromArchive');
  const isProductArchived = locaStates?.fromArchive || Boolean(fromArch);
  const loggedInUserId = userInfo?.userId;

  const OperationalAddEditAccess = CheckActionPermission(logInRights, 'criticalPath', 'operational', 'addEdit');

  const [detailState, setDetailState] = useState({
    searchText: '',
    searchLoaded: false,
    showMobileSearch: false,
    loading: false,
    hasMore: false,
    pageIndex: 1,
    pageSize: Page_Size,
    tableData: { rows: [], columns: [], data: [] },
    filterOptions: [],
    percentageColumns: [],
    showrequiredModal: false,
    requiredFieldsData: [],
    columnOptions: [],
    selectedColumns: [],
  });

  const { columnOptions, selectedColumns } = detailState;
  useEffect(() => {
    const detailInitial = async () => {
      setDetailState((oldData) => ({
        ...oldData,
        loading: true,
      }));
      const lastOpenedParams = {
        modalId: ocpId,
        userId: loggedInUserId,
        type: 'operationalCP',
      };
      await dispatch(
        action.fetchRowColumnDataforOP({
          id: ocpId,
          pageIndex: detailState.pageIndex,
          pageSize: detailState?.pageSize,
        }),
      );
      await dispatch(userAction.fetchUserGroupsCards());
      dispatch(action.lastOpened(lastOpenedParams));
      const res = await dispatch(action.getActiveColumnsofCP(ocpId));
      if (res) {
        const options = createOptions(res, 'name', '_id');
        setDetailState((oldData) => ({
          ...oldData,
          columnOptions: options,
          selectedColumns: options,
          loading: false,
        }));
      }
    };
    detailInitial();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, ocpId]);

  useEffect(() => {
    if (ocpRowColData) {
      const table = cloneDeep(detailState.tableData);
      const percentCol = ocpRowColData?.columns?.filter((columnElement) => {
        return columnElement?.columnType === 'source' && columnElement?.source?.outcome?.value !== 'date_added';
      });
      table.rows = [...(ocpRowColData.rows ?? [])];
      table.columns = [...(ocpRowColData.columns ?? [])];
      table.data = [...(ocpRowColData.result ?? [])];
      const count = totalDetailsRow;
      setDetailState((oldData) => ({
        ...oldData,
        tableData: table,
        percentageColumns: percentCol,
        // .map((e) => {
        //   return { name: e?.name, _id: e?._id };
        // }),
        hasMore: count !== table.rows.length,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ocpRowColData?.rows, totalDetailsRow]);

  useEffect(() => {
    if (detailState?.tableData?.columns && !isEmpty(detailState?.tableData?.columns)) {
      const hasReuiredColumns = detailState?.tableData?.columns.filter((columnElement) => columnElement?.isRequired).map((colEle) => colEle?._id);
      if (hasReuiredColumns && !isEmpty(hasReuiredColumns)) {
        const toSetReuiredData = [];
        detailState?.tableData?.data.forEach((resultElement) => {
          resultElement.resultObject.forEach((objElement) => {
            if (hasReuiredColumns.includes(objElement.column) && !objElement.result) {
              const rows = detailState?.tableData.rows
                .filter((rowElement) => rowElement?._id.toString() === resultElement.row.toString())
                .map((rEle) => rEle?.name);
              const columns = detailState?.tableData.columns
                .filter((columnElement) => columnElement?._id.toString() === objElement.column.toString())
                .map((cEle) => cEle.name);
              toSetReuiredData.push({
                rowName: rows[0],
                columnNames: columns.join(','),
              });
            }
          });
        });
        setDetailState((oldData) => ({
          ...oldData,
          requiredFieldsData: toSetReuiredData,
        }));
      }
    }
  }, [detailState?.tableData]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (detailState.searchLoaded) {
        const table = cloneDeep(detailState.tableData);
        table.data = [];
        setDetailState((debouncestate) => ({
          ...debouncestate,
          loading: true,
          pageIndex: 1,
          tableData: table,
          hasMore: true,
          selectedIdArray: [],
        }));
        const optns = {
          pageIndex: 1,
          pageSize: detailState.pageSize,
          searchText: detailState.searchText,
          id: ocpId,
        };
        dispatch(action.clearReducer());
        const res = dispatch(action.fetchRowColumnDataforOP({ ...optns }));
        res &&
          setDetailState((debstate) => ({
            ...debstate,
            loading: false,
            searchLoaded: false,
          }));
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detailState.searchText, dispatch, detailState.pageIndex, detailState.pageSize]);

  useEffect(() => {
    if (userGroupsCardList) {
      const options = [
        {
          name: 'Assignee',
          option: [...userGroupsCardList],
          placeholder: t('OPERATIONAL_CP.DETAILS_OPERATIONAL_CP.SELECT_ASSIGNEE'),
          noOption: t('OPERATIONAL_CP.DETAILS_OPERATIONAL_CP.NO_ASSIGNEE'),
          value: null,
        },
        {
          name: 'Completion',
          option: [...complitionPercentage],
          placeholder: t('OPERATIONAL_CP.DETAILS_OPERATIONAL_CP.NO_COMPLETION'),
          noOption: t('OPERATIONAL_CP.DETAILS_OPERATIONAL_CP.NO_COMPLETEION_AVAILBLE'),
          value: null,
        },
      ];
      setDetailState((previousDetails) => ({
        ...previousDetails,
        filterOptions: [...options],
      }));
    }
  }, [userGroupsCardList]);

  const onChangeFilter = async (name, e) => {
    let { filterOptions } = detailState;
    switch (name) {
      case 'option_0_Assignee':
        filterOptions[0].value = e;
        break;
      case 'option_1_Completion':
        filterOptions[1].value = e;
        const exist = filterOptions.find((ele) => ele.name === 'Column');
        if (e) {
          !exist &&
            filterOptions.push({
              name: 'Column',
              option: [...(detailState.percentageColumns ?? [])],
              placeholder: t('OPERATIONAL_CP.DETAILS_OPERATIONAL_CP.SELECT_COLUMN'),
              noOption: t('OPERATIONAL_CP.DETAILS_OPERATIONAL_CP.NO_COLUMN_AVAILBLE'),
              value: null,
            });
        } else {
          const fOArray = cloneDeep(filterOptions);
          filterOptions = fOArray.filter((e) => e?.name !== 'Column');
        }
        break;
      case 'option_2_Column':
        filterOptions[2].value = e;
        break;
      case 'clear':
        filterOptions[0].value = null;
        filterOptions[1].value = null;
        if (filterOptions.length === 3) {
          filterOptions[2].value = null;
        }
        const clearArray = cloneDeep(filterOptions);
        filterOptions = clearArray.filter((e) => e?.name !== 'Column');
        filterSubmitted(filterOptions);
        break;

      default:
        filterSubmitted(filterOptions);
        break;
    }
    setDetailState((previousDetails) => ({
      ...previousDetails,
      filterOptions: [...filterOptions],
    }));
  };

  const filterSubmitted = async (filterOptions) => {
    const assigneIdsToSubmit = filterOptions.filter((e) => e?.name === 'Assignee' && e?.value).map((mapEle) => mapEle?.value?._id);
    const complitionToSubmit = filterOptions.filter((e) => e?.name === 'Completion' && e?.value).map((mapEle) => mapEle?.value?._id);
    const columnId = filterOptions.filter((e) => e?.name === 'Column' && e?.value).map((mapEle) => mapEle?.value?._id);

    setDetailState((oldData) => ({
      ...oldData,
      loading: true,
    }));
    const params = {
      id: ocpId,
      pageIndex: detailState.pageIndex,
      pageSize: detailState?.pageSize,
    };

    if (assigneIdsToSubmit && !isEmpty(assigneIdsToSubmit)) {
      params.assignee = assigneIdsToSubmit[0];
    }
    if (complitionToSubmit && !isEmpty(complitionToSubmit) && columnId && !isEmpty(columnId)) {
      params.percentageRang = {
        range: complitionToSubmit[0],
        column: columnId[0],
      };
    }

    await dispatch(action.clearReducer());
    const res = await dispatch(action.fetchRowColumnDataforOP(params));
    res &&
      setDetailState((oldData) => ({
        ...oldData,
        loading: false,
      }));
  };

  const handleSearch = (e) => {
    const targetValue = e.target.value;
    setDetailState((searchState) => ({
      ...searchState,
      searchText: targetValue,
      searchLoaded: true,
    }));
  };

  const handleMobileSearch = (clear) => {
    if (clear) {
      setDetailState((mobstate) => ({
        ...mobstate,
        searchText: '',
        searchLoaded: true,
        showMobileSearch: !detailState.showMobileSearch,
      }));
    }
  };

  const redirectToListingPage = async () => {
    await dispatch(action.clearReducer());
    isProductArchived ? history.push('/operational-cp?fromArchive=true') : history.push('/operational-cp');
    setDetailState((oldData) => ({
      ...oldData,
      tableData: { columns: [], rows: [], data: [] },
    }));
  };

  const changeManualInputs = (value, rowId, colId) => {
    const tables_Data = cloneDeep(detailState?.tableData);
    const dataArray = cloneDeep(detailState?.tableData?.data);
    const findex = dataArray.findIndex((e) => e?.row === rowId);
    if (findex !== -1) {
      let resultIndex = -1;
      resultIndex = dataArray[findex]?.resultObject?.findIndex((resObjEle) => resObjEle.column === colId);
      const switchkeys =
        typeof dataArray[findex].resultObject[resultIndex].resultType === 'object'
          ? dataArray[findex].resultObject[resultIndex].resultType?.key
          : dataArray[findex].resultObject[resultIndex].resultType;
      if (resultIndex !== -1) {
        switch (switchkeys) {
          case 'Checkbox':
            const getValue = dataArray[findex].resultObject[resultIndex].result;
            dataArray[findex].resultObject[resultIndex].result = {
              ...getValue,
              ...value,
            };
            break;
          case 'Dropdown':
            dataArray[findex].resultObject[resultIndex].result = value?._id;
            break;
          default:
            dataArray[findex].resultObject[resultIndex].result = value;
            break;
        }
      }
    }
    tables_Data.data = dataArray;
    setDetailState((oldData) => ({
      ...oldData,
      tableData: tables_Data,
    }));
  };

  const disableCondition = (item) => {
    const group = userGroupsCardList.find((e) => e?._id === item?.assignee);
    const groupUsers = group?.users;
    return (
      isProductArchived ||
      !OperationalAddEditAccess ||
      (isSupplierLoggedIn && item?.assignee !== loggedInUserId) ||
      (OperationalAddEditAccess && isCompanyUserLoggedIn && item?.assignee && group && !groupUsers?.some((user) => user?._id === loggedInUserId))
    );
  };

  const renderManualCells = (rowElement, columnElement) => {
    const { data } = detailState.tableData;
    const foundIndex = data.findIndex((e) => e?.row === rowElement?._id);
    let resultIndex = -1;
    resultIndex = data[foundIndex]?.resultObject?.findIndex((e) => e.column === columnElement?._id);

    if (rowElement.manualType?.key) {
      return (
        <RenderingManualItems
          {...rowElement}
          keyName={rowElement?.manualType?.key}
          keyprop={`${rowElement?.manualType?.key}_${columnElement?._id}_${rowElement._id}`}
          value={data[foundIndex]?.resultObject[resultIndex]?.result || null}
          placeholder={shortenString(`Enter ${columnElement.name}`, 25)}
          disableCondition={disableCondition(rowElement)}
          change={(e) => changeManualInputs(e, rowElement?._id, columnElement?._id)}
          options={rowElement?.options}
          characterLimit={rowElement?.characterLimit}
          labelColours={rowElement?.labelColoursOptions}
          subType={rowElement?.manualType?.subType}
          status={rowElement?.status}
          isFromPim
        />
      );
    }
    if (rowElement?.rowType !== 'manual' && columnElement.manualType?.key) {
      return (
        <RenderingManualItems
          {...columnElement}
          keyName={columnElement?.manualType?.key}
          keyprop={`${columnElement?.manualType?.key}_${columnElement?._id}_${rowElement._id}`}
          value={data[foundIndex]?.resultObject[resultIndex]?.result || null}
          placeholder={shortenString(`Enter ${columnElement.name}`, 25)}
          disableCondition={disableCondition(rowElement)}
          change={(e) => changeManualInputs(e, rowElement?._id, columnElement?._id)}
          options={columnElement?.options}
          characterLimit={columnElement?.characterLimit}
          labelColours={columnElement?.labelColoursOptions}
          subType={columnElement?.manualType?.subType}
          status={columnElement?.status}
          isFromPim
        />
      );
    }
  };

  const tdValue = (element, colEle) => {
    let answer = null;
    detailState.tableData.data.forEach((e) => {
      if (e?.row === element?._id) {
        answer = e?.resultObject.find((e) => e?.column === colEle?._id);
      }
    });
    return answer?.result ? hasResult(colEle, answer) : '--';
  };

  const hasResult = (colEle, answer) => {
    return !['first_item', 'last_item'].includes(colEle?.source?.attribute?.value) ||
      (['first_item', 'last_item'].includes(colEle?.source?.attribute?.value) && colEle.source.outcome.value === 'percentage_of_date_added')
      ? `${answer?.result} %`
      : moment(answer?.result).format('DD-MMM-YYYY');
  };

  const saveDetailOCP = async () => {
    const columns = detailState.tableData.columns.filter((colEle) => colEle.columnType === 'manual').map((e) => e?._id);
    const rows = detailState.tableData.rows.filter((rowEle) => rowEle.rowType === 'manual').map((e) => e?._id);
    const rowIds = detailState.tableData.rows.map((e) => e?._id);
    const filteredData = [];
    const requiredColumns = detailState.tableData.columns.filter((colEle) => colEle.isRequired).map((e) => e?._id);
    const incompleteFields = [];
    if (requiredColumns && !isEmpty(requiredColumns)) {
      detailState.tableData.data.forEach((mainElement) => {
        mainElement.resultObject.forEach((internalElement) => {
          if (requiredColumns.includes(internalElement.column) && !internalElement?.result) {
            incompleteFields.push(internalElement);
          }
        });
      });
    }
    detailState.tableData.data.forEach((dataEle) => {
      if (rows.includes(dataEle.row)) {
        filteredData.push(dataEle);
      } else {
        filteredData.push({
          row: dataEle.row,
          resultObject: dataEle.resultObject.filter((resultEle) => columns.includes(resultEle.column)),
        });
      }
    });
    if (incompleteFields && isEmpty(incompleteFields)) {
      const object = {
        operationalCPId: ocpId,
        manualData: {
          rowIds,
          colIds: columns,
          data: filteredData,
        },
      };
      dispatch(action.addManualData(object, t));
    } else {
      toasterMsg(t('OPERATIONAL_CP.DETAILS_OPERATIONAL_CP.PLEASE_FILL_REQUIRED_DETAILS'), 'danger');
    }
  };

  const handleNextPageInScroll = async () => {
    let { pageIndex } = detailState;
    pageIndex += 1;
    setDetailState((nextPagestate) => ({
      ...nextPagestate,
      pageIndex,
      loading: true,
      id: ocpId,
    }));
    const params = {
      pageIndex,
      pageSize: detailState?.pageSize,
      searchText: detailState.searchText,
      id: ocpId,
    };
    dispatch(action.clearReducer());
    const result = dispatch(action.fetchRowColumnDataforOP(params));
    if (result) {
      setDetailState((nextPagestate) => ({
        ...nextPagestate,
        loading: false,
      }));
    }
  };

  const manualDateCondition = (colEle) => {
    return colEle?.columnType === 'manual' && colEle?.isColourCodingActive && colEle?.manualType?.key === 'Date_picker';
  };
  const manualNumberCondition = (colEle) => {
    return colEle?.columnType === 'manual' && colEle?.isColourCodingActive && colEle?.manualType?.key === 'Number_percentage';
  };
  const sourceColourCoading = (colEle, element) => {
    return colEle?.isColourCodingActive && colEle?.columnType === 'source' && element?.rowType === 'source';
  };

  const forManualData = (element, verifyAgainst, colEle, dateCol) => {
    let returnColour = 'cell-grey';
    detailState?.tableData?.data?.forEach((detailData) => {
      if (detailData?.row === element?._id && !isEmpty(detailData?.resultObject) && verifyAgainst) {
        colEle?.colourCoding?.forEach((cEle) => {
          const manaualCheckFrom = detailData?.resultObject.find((e) => e?.column === cEle?.colourValue)?.result;
          if (manaualCheckFrom && !dateCol && cEle?.colourValue) {
            const dtColour = toCheckDate(cEle, verifyAgainst, manaualCheckFrom);
            if (dtColour) {
              dateCol = true;
              returnColour = colourSwitch(dtColour);
            }
          }
        });
      }
    });
    return returnColour;
  };

  const forNumberCondition = (element, verifyAgainst, colEle, manualNumCol) => {
    let numCol = 'cell-grey';
    detailState?.tableData?.data?.forEach((detailData) => {
      if (detailData?.row === element?._id && !isEmpty(detailData?.resultObject) && verifyAgainst) {
        colEle?.colourCoding?.forEach((cEle) => {
          if (!manualNumCol) {
            const number = percentageCheck(cEle, verifyAgainst);
            if (number) {
              manualNumCol = true;
              numCol = colourSwitch(number);
            }
          }
        });
      }
    });
    return numCol;
  };

  const forPercentageCal = (colEle, verifyAgainst, percentageCalculated) => {
    let percentCol = 'cell-grey';
    colEle?.colourCoding?.forEach((percentageElement) => {
      if (verifyAgainst && !percentageCalculated) {
        const percent = percentageCheck(percentageElement, verifyAgainst);
        if (percent) {
          percentageCalculated = true;
          percentCol = colourSwitch(percent);
        }
      }
    });
    return percentCol;
  };

  const forDate = (element, verifyAgainst, colEle, dtCol) => {
    let dateCol = 'cell-grey';
    detailState?.tableData?.data?.forEach((dataDetails) => {
      if (dataDetails?.row === element?._id && !isEmpty(dataDetails?.resultObject) && verifyAgainst) {
        colEle?.colourCoding?.forEach((ccEle) => {
          const toCheckFrom = dataDetails?.resultObject.find((e) => e?.column === ccEle?.colourValue)?.result;
          if (!dtCol && ccEle?.colourValue) {
            const dateColour = toCheckDate(ccEle, verifyAgainst, toCheckFrom);
            if (dateColour) {
              dtCol = true;
              dateCol = colourSwitch(dateColour);
            }
          }
        });
      }
    });
    return dateCol;
  };

  const colourClassName = (colEle, element) => {
    if (element?.rowType === 'manual') {
      return false;
    }
    let sourceColour = 'cell-grey';
    const mainObject = detailState?.tableData?.data?.find((details) => details?.row === element?._id);
    const verifyAgainst = mainObject?.resultObject?.find((resEle) => resEle?.column === colEle?._id)?.result;
    if (manualDateCondition(colEle)) {
      const dateCol = false;
      sourceColour = forManualData(element, verifyAgainst, colEle, dateCol);
      return sourceColour;
    }
    if (manualNumberCondition(colEle)) {
      const manualNumCol = false;
      sourceColour = forNumberCondition(element, verifyAgainst, colEle, manualNumCol);
      return sourceColour;
    }
    if (sourceColourCoading(colEle, element)) {
      if (colEle?.source?.outcome?.value === 'date_added') {
        const dtCol = false;
        sourceColour = forDate(element, verifyAgainst, colEle, dtCol);
      } else {
        const percentageCalculated = false;
        sourceColour = forPercentageCal(colEle, verifyAgainst, percentageCalculated);
      }
      return sourceColour;
    }
    if (colEle?.isColourCodingActive && element?.rowType === 'manual') {
      return sourceColour;
    }
  };

  const colourSwitch = (percent) => {
    switch (percent) {
      case 'green':
        return 'cell-green';
      case 'red':
        return 'cell-red';
      case 'amber':
        return 'cell-amber';
      default:
        return 'cell-grey';
    }
  };

  const toCheckDate = (ccEle, verifyAgainst, toCheckFrom) => {
    if (ccEle?.colourType === 'green') {
      return (moment.utc(verifyAgainst).isBefore(moment.utc(toCheckFrom)) || moment.utc(verifyAgainst).isSame(moment.utc(toCheckFrom))) && 'green';
    }
    if (ccEle?.colourType === 'amber') {
      const toamberCheck = moment(toCheckFrom).add(ccEle.endPercentage, 'days');

      const isBetweenDates = moment(verifyAgainst).isBetween(toCheckFrom, toamberCheck, 'day', '[]');
      const isSameAsStart = moment(verifyAgainst).isSame(toCheckFrom, 'day');
      const isSameAsEnd = moment(verifyAgainst).isSame(toamberCheck, 'day');

      return (isBetweenDates || isSameAsStart || isSameAsEnd) && 'amber';
    }
    if (ccEle?.colourType === 'red') {
      return (moment.utc(verifyAgainst).isAfter(moment.utc(toCheckFrom)) || moment.utc(verifyAgainst).isSame(moment.utc(toCheckFrom))) && 'red';
    }
    return 'deleted';
  };

  const percentageCheck = (percentageElement, percetageToCheck) => {
    if (percentageElement?.colourValue === 'equal') {
      return percentageElement?.startPercentage === percetageToCheck && percentageElement?.colourType;
    }
    if (percentageElement?.colourValue === 'greater_than') {
      return percentageElement?.startPercentage <= percetageToCheck && percentageElement?.colourType;
    }
    if (percentageElement?.colourValue === 'between') {
      return percentageElement?.startPercentage <= percetageToCheck && percentageElement?.endPercentage >= percetageToCheck && percentageElement?.colourType;
    }
    if (percentageElement?.colourValue === 'less_than') {
      return percentageElement?.startPercentage >= percetageToCheck && percentageElement?.colourType;
    }
    return 'deleted';
  };

  const filterDisableOption = () => {
    const ifcomplition =
      detailState.filterOptions
        ?.filter((optionEle) => {
          let valid = false;
          if ((optionEle?.name === 'Completion' && optionEle?.value) || optionEle?.name === 'Column') {
            valid = optionEle?.name === 'Column' && !optionEle?.value;
          }
          return valid;
        })
        .map((e) => e === true).length > 0;
    return detailState.loading || ifcomplition;
  };

  const forColourTDManual = (rowElement, columnElement) => {
    const { data } = detailState.tableData;
    const foundIndex = data.findIndex((e) => e?.row === rowElement?._id);
    let resultIndex = -1;
    resultIndex = data[foundIndex]?.resultObject?.findIndex((e) => e.column === columnElement?._id);
    if (typeof data[foundIndex]?.resultObject[resultIndex]?.result === 'object' && isNaN(Date.parse(data[foundIndex]?.resultObject[resultIndex]?.result))) {
      if (!data[foundIndex]?.resultObject[resultIndex]?.result) {
        return !data[foundIndex]?.resultObject[resultIndex]?.result;
      }
      for (const key in data[foundIndex]?.resultObject[resultIndex]?.result) {
        if (data[foundIndex]?.resultObject[resultIndex]?.result.hasOwnProperty(key) && data[foundIndex]?.resultObject[resultIndex]?.result[key] !== false) {
          return !data[foundIndex]?.resultObject[resultIndex]?.result;
        }
      }
    } else {
      return !data[foundIndex]?.resultObject[resultIndex]?.result;
    }
  };

  const showrequiredFields = () => {
    setDetailState((reqFields) => ({
      ...reqFields,
      showrequiredModal: true,
    }));
  };
  const toggleReqFields = () => {
    setDetailState((reqFields) => ({
      ...reqFields,
      showrequiredModal: false,
    }));
  };

  const incompleteCell = () => {
    const noOfRequiredCells = [];
    const requiredColumn = uniqBy(detailState.tableData.columns.filter((colEle) => colEle?.isRequired).map((col) => col?._id));
    if (requiredColumn && !isEmpty(requiredColumn)) {
      detailState.tableData.data.forEach((dataEle) => {
        noOfRequiredCells.push(...dataEle.resultObject.filter((colEle) => requiredColumn.includes(colEle.column) && !colEle.result));
      });
    }

    return noOfRequiredCells.length;
  };

  const multiSelectChange = (e) => {
    setDetailState((prev) => ({
      ...prev,
      selectedColumns: e,
    }));
  };

  const downloadOCPDetailsExcel = async () => {
    const assigneIdsToSubmit = detailState?.filterOptions?.filter((e) => e?.name === 'Assignee' && e?.value).map((mapEle) => mapEle?.value?._id);
    const complitionToSubmit = detailState?.filterOptions?.filter((e) => e?.name === 'Completion' && e?.value).map((mapEle) => mapEle?.value?._id);
    const columnId = detailState?.filterOptions?.filter((e) => e?.name === 'Column' && e?.value).map((mapEle) => mapEle?.value?._id);
    const body = {
      timeZone,
      ocpId,
      filterObj: {},
      ocpSlugLink: window.location.href,
    };
    if (assigneIdsToSubmit && !isEmpty(assigneIdsToSubmit)) {
      body.filterObj.assignee = assigneIdsToSubmit[0];
    }
    if (complitionToSubmit && !isEmpty(complitionToSubmit) && columnId && !isEmpty(columnId)) {
      body.filterObj.percentageRang = {
        range: complitionToSubmit[0],
        column: columnId[0],
      };
    }
    await dispatch(action.downloadOCPExcel(body, t));
  };

  const mainDetails = () => {
    return isEmpty(detailState?.tableData?.rows) ? (
      <Container fluid className="py-4">
        <Row>
          <Col md="12">
            <p className="alert alert-info override-alert-info justify-content-center align-item-center d-flex">
              {t('OPERATIONAL_CP.DETAILS_OPERATIONAL_CP.NO_OPERATIONAL_FOUND')}
            </p>
          </Col>
        </Row>
      </Container>
    ) : (
      <div className="scroll-container">
        <span className="top" />
        <span className="left" />
        <span className="right" />
        <div className="all-scroll">
          <div
            id="task_table"
            style={{
              height: 'calc(100vh - 170px)',
              overflow: 'scroll',
            }}
          >
            <InfiniteScroll
              dataLength={detailState?.tableData?.rows?.length}
              loader={detailState.loading && <Loader />}
              hasMore={detailState.hasMore}
              next={handleNextPageInScroll}
              scrollableTarget="task_table"
              className="fixed-col-container"
            >
              <table
                className={`table custom-table m-0 layout-fixed ocp-detail-table ${detailState?.tableData?.columns?.length + 3 > 5 && 'content-overflow'}`}
                id="task_table"
              >
                <thead>
                  <tr>
                    <th className="w-300px w-xs-150px"> {t('OPERATIONAL_CP.DETAILS_OPERATIONAL_CP.TASK_LIST')}</th>
                    <th className={`w-280px w-xs-150px ${detailState?.tableData?.columns?.length && lastFixColClass}`}>
                      {t('OPERATIONAL_CP.DETAILS_OPERATIONAL_CP.ASSIGNEE')}
                    </th>
                    {detailState?.tableData?.columns?.map((columnElement, columnIndex) => {
                      const found = selectedColumns?.find((col) => col?._id === columnElement?._id);
                      return (
                        found && (
                          <th className="w-250px" key={columnElement?._id}>
                            {columnElement?.name}
                          </th>
                        )
                      );
                    })}
                    <th className={`w-80px ${detailState?.tableData?.columns?.length && lastFixColClass}`}>
                      {t('OPERATIONAL_CP.DETAILS_OPERATIONAL_CP.ACTION')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {detailState?.tableData?.rows?.map((element, index) => {
                    return (
                      <tr key={`${element?._id}_${index}`}>
                        <td>{element?.name}</td>
                        <td className={detailState?.tableData?.columns?.length && lastFixColClass}>
                          {userGroupsCardList?.find((ele) => ele?._id?.toString() === element?.assignee?.toString())?.name}
                        </td>
                        {detailState.tableData.columns?.map((colEle) => {
                          const found = selectedColumns?.find((col) => col?._id === colEle?._id);
                          return (
                            found &&
                            (colEle?.columnType === 'manual' || element?.rowType === 'manual' ? (
                              <td
                                key={`manual_${element?._id}_${colEle?._id}`}
                                className={`position-relative ${
                                  (colEle?.isRequired && forColourTDManual(element, colEle) && 'cell-red-required') || colourClassName(colEle, element)
                                }`}
                              >
                                {renderManualCells(element, colEle)}
                              </td>
                            ) : (
                              <td
                                key={`source_${element?._id}_${colEle?._id}`}
                                className={`position-relative text-center ${
                                  (colEle?.isRequired && !tdValue(element, colEle) && 'cell-red-required') || colourClassName(colEle, element)
                                }`}
                              >
                                {tdValue(element, colEle)}
                              </td>
                            ))
                          );
                        })}
                        {/* dynamic column and row value logic */}
                        <td className="px-1 increase-z-index">
                          {' '}
                          <div className="action-btns d-flex align-items-center test-action-btns">
                            <button className="btn btn-action-icon " style={{ margin: '0' }}>
                              <div className="info-container testing-action-spaceremoval">
                                <span className="icon-info f-14" />
                                <div className="info-content">
                                  {element?.createdBy?.firstName && (
                                    <p className="text-left text-nowrap m-0">
                                      <strong>{t('OPERATIONAL_CP.DETAILS_OPERATIONAL_CP.CREATED')} </strong> :{' '}
                                      {`${element?.createdBy?.firstName} ${element?.createdBy?.lastName} | `}
                                      {moment(element?.createdAt).format('DD-MMMM-YYYY, h:mm a')}
                                    </p>
                                  )}
                                  {element?.modifiedBy?.firstName && (
                                    <p className="text-left text-nowrap m-0">
                                      <strong>{t('OPERATIONAL_CP.DETAILS_OPERATIONAL_CP.MODIFIED')} </strong> :{' '}
                                      {`${element?.modifiedBy?.firstName} ${element?.modifiedBy?.lastName} | `}
                                      {moment(element?.updatedAt).format('DD-MMMM-YYYY, h:mm a')}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </InfiniteScroll>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="title">{t('OPERATIONAL_CP.DETAILS_OPERATIONAL_CP.OPERATIONAL_CRITICAL_PATH')}</h4>
        </div>
        <div className="search-filter">
          <div className="action-btns d-flex align-items-center test-action-btns">
            {incompleteCell() > 0 && (
              <>
                <button type="button" className="btn btn-action-icon " style={{ margin: '0' }} onClick={showrequiredFields}>
                  <span className="icon-info f-14" />
                </button>
                <p className="px-2 f-14 m-0 d-none d-md-block">
                  {incompleteCell()} {t('OPERATIONAL_CP.DETAILS_OPERATIONAL_CP.REQUIRED_FIELD')}
                </p>
              </>
            )}
          </div>
          <SearchBar
            onSearch={handleSearch}
            value={detailState.searchText}
            showMobileSearch={detailState.showMobileSearch}
            placeholder={t('OPERATIONAL_CP.DETAILS_OPERATIONAL_CP.SEARCH_TASK')}
            handleMobileSearch={handleMobileSearch}
          />
          <FilterButton
            detailList={detailState.filterOptions}
            onBtnClick={onChangeFilter}
            isDisable={filterDisableOption()}
            isMultiSelectOption={[{ option: columnOptions, value: selectedColumns }]}
            multiSelectChange={multiSelectChange}
          />
          {isEmpty(detailState?.tableData?.rows) ? null : (
            <button type="button" className="filter-btn" onClick={downloadOCPDetailsExcel} title={t('OPERATIONAL_CP.DETAILS_OPERATIONAL_CP.DOWNLOAD_OCP')}>
              <i className="icon-download" />
            </button>
          )}
          {OperationalAddEditAccess && (
            <>
              <button
                title={t('OPERATIONAL_CP.DETAILS_OPERATIONAL_CP.TITLE')}
                type="button"
                className="btn btn-white btn-back-lib d-none d-md-block"
                onClick={saveDetailOCP}
                disabled={detailState.loading || isProductArchived}
              >
                {t('OPERATIONAL_CP.DETAILS_OPERATIONAL_CP.TITLE')}
              </button>
              <button title="Save" type="button" className="filter-btn d-md-none" onClick={saveDetailOCP} disabled={detailState.loading || isProductArchived}>
                <span className="icon-Save" />
              </button>
            </>
          )}
          <BtnBack backTriggered={redirectToListingPage} />
        </div>
      </div>
      {detailState.loading ? <Loader /> : mainDetails()}
      {detailState.showrequiredModal && (
        <RequiredFieldModal
          onOpen={detailState.showrequiredModal}
          toggle={toggleReqFields}
          title={t('OPERATIONAL_CP.DETAILS_OPERATIONAL_CP.REQUIRED_FIEDS')}
          mainContent={detailState.requiredFieldsData}
        />
      )}
    </>
  );
}

export default DetailsOprationalCPPage;
